(function() {
  // 等待DOM加载完成
  document.addEventListener('DOMContentLoaded', function() {
    initVideoPlayers();
  });

  function initVideoPlayers() {
    // 查找所有视频容器
    const videoContainers = document.querySelectorAll('.video');
    
    videoContainers.forEach(function(container) {
      const playButton = container.querySelector('[data-video-play-button]');
      const videoCover = container.querySelector('[data-video-cover]');
      const videoElement = container.querySelector('[data-video-element]');
      
      if (!playButton || !videoElement) return;
      
      // 添加点击事件
      playButton.addEventListener('click', function() {
        const videoUrl = videoElement.getAttribute('data-video-url');
        const platform = container.getAttribute('data-video');
        
        // 显示加载图标
        playButton.classList.add('loading');
        
        // 根据平台加载视频
        if (platform === 'youtube') {
          loadYouTubeVideo(videoUrl, videoElement, videoCover);
        } else if (platform === 'vimeo') {
          loadVimeoVideo(videoUrl, videoElement, videoCover);
        }
      });
    });
  }

  function loadYouTubeVideo(url, element, cover) {
    // 提取YouTube视频ID
    let videoId = '';
    if (url.includes('youtube.com')) {
      const urlParams = new URLSearchParams(url.split('?')[1]);
      videoId = urlParams.get('v');
    } else if (url.includes('youtu.be')) {
      videoId = url.split('/').pop().split('?')[0];
    }
    
    if (!videoId) return;
    
    // 创建iframe
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    
    // 替换内容并隐藏封面
    element.innerHTML = '';
    element.appendChild(iframe);
    if (cover) cover.style.display = 'none';
  }

  function loadVimeoVideo(url, element, cover) {
    // 提取Vimeo视频ID
    const matches = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    const videoId = matches ? matches[1] : null;
    
    if (!videoId) return;
    
    // 创建iframe
    const iframe = document.createElement('iframe');
    iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';
    iframe.allow = 'autoplay; fullscreen';
    iframe.allowFullscreen = true;
    
    // 替换内容并隐藏封面
    element.innerHTML = '';
    element.appendChild(iframe);
    if (cover) cover.style.display = 'none';
  }
})();